import React from "react";
import SidebarSettings from "../../components/SidebarSettings/sidebarSettings.component";

export default function SidebarSettingsPage() {
  return <SidebarSettings />;
}

